import {AutoComplete, Button, Col, Form, Input, Radio, Row, Select, Tag, Tooltip} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, {useContext, useEffect, useMemo, useState} from "react";
import { violenceDocumentStorage } from "../../../constants/incident.constant";
import { getMappedData } from "../util";
import {GlobalContext} from "../../../context/GlobalContext";
import {roleValues} from "../../../config/roles";
const { Option } = Select;
export default function BasicInfo(props) {
  const { user } = useContext(GlobalContext);
  const [referrals, setReferrals] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setTimeout(() => {
      if (props.form.getFieldValue('referrals') && props.form.getFieldValue('referrals').length > 0) {
        // console.log(props.form.getFieldValue('referrals'), 'kiran');
        setReferrals(props.form.getFieldValue('referrals'))
      }
    }, 1000);

  }, []);
  const handleClose = (removedReferral) => {
    const newReferrals = referrals.filter((referral) => referral !== removedReferral);
    setReferrals(newReferrals);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !referrals.includes(inputValue)) {
      const updatedReferrals = [...referrals, inputValue];
      setReferrals(updatedReferrals);
      props.form.setFieldValue("referrals", updatedReferrals);
    }
    setInputVisible(false);
    setInputValue("");
  };
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
            name="fullName"
            label="Full Name"
            rules={[{ required: false, message: "Please input the full name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} xl={12}>
          <Form.Item
            name="personalCode"
            label="Personal Code"
            rules={[{ required: user.role === roleValues.projectCoordinator, message: "Please input the personal code!" }, {}]}
            extra={user.role !== roleValues.projectCoordinator && <i>Note: only project coordinator can provide personal code.</i>}
          >
            <Input readOnly={user.role !== roleValues.projectCoordinator}/>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
            name="address"
            label="Address"
            rules={[{ required: true, message: "Please input the address!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} xl={12}>
          <Form.Item
            name="age"
            label="Age"
            rules={[
              { required: true, message: "Please input the age!" },
              {
                validator: (_, value) => {
                  // if (value === undefined || value === '') {
                  //   return Promise.reject(new Error('Please input the age!'));
                  // }
                  const numberValue = Number(value);
                  if (isNaN(numberValue) || numberValue < 0 || numberValue > 120) {
                    return Promise.reject(new Error('Age must be between 0 and 120!'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="number"/>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
              name="maritalStatus"
              label="Marital Status"
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Select>
                <Option value={"single"} >Single</Option>
                <Option value={"married"} >Married</Option>
                <Option value={"divorced"} >Divorced</Option>
                <Option value={"widowed"} >Widowed</Option>
              </Select>
            </Form.Item>
          </Col>
        <Col xs={24} xl={12}>
          <Form.Item
              name="referencePersonCodeName"
              label="Code Name of the Reference Person"
              rules={[{ required: true, message: "Please input the value!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
              name="gender"
              label="Gender"
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Select>
                <Option value={"male"} >Male</Option>
                <Option value={"female"} >Female</Option>
                <Option value={"other"} >Other</Option>
              </Select>
            </Form.Item>
          </Col>

        <Col xs={24} xl={12}>
          <Form.Item
              name="contactNumber"
              label="Contact Number"
              extra={user.role !== roleValues.projectCoordinator && <i>Note: only project coordinator can provide contact number.</i>}
              rules={[
                {
                  required: user.role === roleValues.projectCoordinator,
                  message: "",
                },
                {
                  validator: (_, value) => {
                    if (user.role === roleValues.projectCoordinator) {
                      if (value === undefined || value === '') {
                        return Promise.reject(new Error('Please input the valid contact number!'));
                      }
                      if (value.length !== 10) {
                        return Promise.reject(new Error('Length of contact number must be 10!'));
                      }
                    }
                    return Promise.resolve();
                  },
                },
              ]}
          >
            <Input type="number" readOnly={user.role !== roleValues.projectCoordinator}/>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          {/* <Form.Item
            name="religion"
            label="Religion"
            rules={[{ required: true, message: "Please input the religion!" }]}
          >
            <Input />
          </Form.Item> */}
          <Form.Item
              name="religion"
              label="Religion"
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Select>
                <Option value={"Hinduism"} >Hinduism</Option>
                <Option value={"Buddhism"} >Buddhism</Option>
                <Option value={"Islam"} >Islam</Option>
                <Option value={"Christianity"} >Christianity</Option>
                <Option value={"Kirant"} >Kirant</Option>
                <Option value={"Jainism"} >Jainism</Option>
                <Option value={"Sikhism"} >Sikhism</Option>
              </Select>
            </Form.Item>
        </Col>
        <Col xs={24} xl={12}>
          {/* <Form.Item
            name="caste"
            label="Caste/Ethnicity"
            rules={[{ required: true, message: "Please input the caste!" }]}
          >
            <Input />
          </Form.Item> */}
          <Form.Item
              name="caste"
              label="Caste/Ethnicity"
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Select>
                <Option value="Brahmin">Brahmin</Option>
                <Option value="Chhetri">Chhetri</Option>
                <Option value="Dalit">Dalit</Option>
                <Option value="Newar">Newar</Option>

                <Option value="Magar">Magar</Option>
                <Option value="Tamang">Tamang</Option>
                <Option value="Rai">Rai</Option>
                <Option value="Limbu">Limbu</Option>
                <Option value="Sherpa">Sherpa</Option>
                <Option value="Tharu">Tharu</Option>
                <Option value="Gurung">Gurung</Option>
                <Option value="Thakali">Thakali</Option>
                <Option value="Chepang">Chepang</Option>

                <Option value="Madhesi">Madhesi</Option>
                <Option value="Muslim">Muslim</Option>


                <Option value="Raute">Raute</Option>
                <Option value="Bote">Bote</Option>
                <Option value="Majhi">Majhi</Option>
                <Option value="Danuwar">Danuwar</Option>
              </Select>
            </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
            name="noOfChildren"
            label="No of Children"
            rules={[
               { required: true, message: "" },
              {
                validator: (_, value) => {
                  if (value === undefined || value === '') {
                    return Promise.reject(new Error('Please input the no of children!'));
                  }
                  const numberValue = Number(value);
                  if (isNaN(numberValue) || numberValue < 0 || numberValue > 20) {
                    return Promise.reject(new Error('Pleasae input the valid no of children!'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
        <Col xs={24} xl={12}>
          <Form.Item
            name="sourceOfLivelihood"
            label="Employment/Source of Livelihood"
            rules={[
              {
                required: true,
                message: "Please input the source of livelihood!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={12}>
          <Form.Item
              name="languageSpoken"
              label="Language Spoken"
              rules={[
                {
                  required: true,
                  message: "Please select an option!",
                },
              ]}
            >
              <Select>
                <Option value="Nepali">Nepali</Option>
                <Option value="English">English</Option>
                <Option value="Maithili">Maithili</Option>
                <Option value="Bhojpuri">Bhojpuri</Option>
                <Option value="Tharu">Tharu</Option>
                <Option value="Tamang">Tamang</Option>
                <Option value="Newari">Newari</Option>
                <Option value="Magar">Magar</Option>
                <Option value="Doteli">Doteli</Option>
                <Option value="Limbu">Limbu</Option>
                <Option value="Gurung">Gurung</Option>
                <Option value="Sherpa">Sherpa</Option>
                <Option value="Rai">Rai</Option>
                <Option value="Awadhi">Awadhi</Option>
                <Option value="Urdu">Urdu</Option>
                <Option value="Chepang">Chepang</Option>
                <Option value="Thakali">Thakali</Option>
                <Option value="Danuwar">Danuwar</Option>
                <Option value="Raute">Raute</Option>
              </Select>
            </Form.Item>
        </Col>
        <Col xs={24} xl={12}>
          <Form.Item
              name="referrals"
              label="Referrals"
              rules={[
                { required: false, message: "Please add at least one referral!" },
              ]}
          >
            <>
              {(referrals || []).map((referral) => {
                const isLongReferral = referral.length > 20;
                const referralElem = (
                    <Tag
                        key={referral}
                        closable
                        onClose={() => handleClose(referral)}
                        style={{ marginBottom: 8 }}
                    >
                      {isLongReferral ? `${referral.slice(0, 20)}...` : referral}
                    </Tag>
                );

                return isLongReferral ? (
                    <Tooltip title={referral} key={referral}>
                      {referralElem}
                    </Tooltip>
                ) : (
                    referralElem
                );
              })}
              {inputVisible ? (
                  <Input
                      size="small"
                      style={{ width: 200, marginBottom: 8 }}
                      value={inputValue}
                      onChange={handleInputChange}
                      onBlur={handleInputConfirm}
                      onPressEnter={handleInputConfirm}
                      autoFocus
                  />
              ) : (
                  <Tag
                      onClick={showInput}
                      style={{ background: "#f0f0f0", borderStyle: "dashed" }}
                  >
                    <PlusOutlined /> New Referral
                  </Tag>
              )}
            </>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
